import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async getMessagerieMessagesByIdDemande(idDemande) {
    return (
      await axios.get(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_MESSAGERIE +
          "/" +
          idDemande
      )
    ).data;
  },

  async postMessagerieMessage(messagerie) {
    return (
      await axios.post(
        process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_MESSAGERIE,
        messagerie
      )
    ).data;
  },

  async putMessagerieMessageLu(temoinGestionnaire, iddemande) {
    return (
      await axios.put(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_MESSAGERIE +
          "/" +
          temoinGestionnaire +
          "/" +
          iddemande
      )
    ).data;
  },
};
